import css from "@/components/Listing/ListingScreen/.module.scss";
import Link from "next/link";
import React from "react";
import Icon from "@/components/icon";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { usePath } from "@/contexts/path/path";
import { useMutation, useQuery } from "@apollo/client";
import { ADD_MOT_LICENSE, REFRESH_LISTING } from "@/graphql/mutations/listing";
import { Modal } from "@aqar-app/react-ui";
import { ErrorModal } from "@/components/error/ssr";
import { SuccessAlert } from "@/components/login-alert";
import PromotionControl from "@/components/Listing/ListingScreen/Promotion/PromotionControl";
import { MotPermitModal } from "@/src/pages/add-listing/daily";
import dayjs from "dayjs";
import RnplControls from "@/components/Listing/ListingScreen/RNPLControl";
import { FINANCING_TEXTS } from "@/graphql/queries/info";
import { trackRequestPreciseLocation } from "@/lib/tracking/trackPreciseLocation";

function ReferralCode({ listing }) {
  return (
    <div className={css.referralButtons}>
      <Link
        className={css.card + " " + css.sov_owner_btn}
        href={`/user/referral-code/${listing.id}`}
        style={{ padding: "12px", gap: "8px" }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.72238 1.96552L7.71455 2.97512C7.09345 3.59731 7.09345 4.61082 7.71455 5.23302C8.33566 5.85521 9.3474 5.85521 9.9685 5.23302L10.9959 4.20385C12.3357 2.86164 14.5506 2.83816 15.867 4.20385C17.1483 5.53433 17.1288 7.64744 15.8241 8.95835L14.7537 10.0306C14.1326 10.6528 14.1326 11.6663 14.7537 12.2885C15.3748 12.9106 16.3866 12.9106 17.0077 12.2885L18.078 11.2162C20.6562 8.63356 20.6406 4.42299 18.0311 1.85987C15.4491 -0.675867 11.281 -0.597603 8.72238 1.96552ZM1.96836 18.1386C4.55044 20.6783 8.71848 20.5961 11.2771 18.033L12.2849 17.0234C12.9061 16.4012 12.9061 15.3877 12.2849 14.7655C11.6638 14.1433 10.6521 14.1433 10.031 14.7655L9.00755 15.7907C7.66768 17.133 5.4528 17.1564 4.13637 15.7907C2.85509 14.4603 2.87462 12.3472 4.17934 11.0362L5.24967 9.96404C5.87077 9.34184 5.87077 8.32833 5.24967 7.70614C4.62856 7.08394 3.61683 7.08394 2.99572 7.70614L1.92539 8.77443C-0.656688 11.361 -0.641063 15.5755 1.96836 18.1386Z"
            fill="#4D4D4D"
          />
          <path
            d="M11.5624 6.17612L6.17945 11.5646C5.55835 12.1867 5.55835 13.2003 6.17945 13.8225C6.80056 14.4446 7.81229 14.4446 8.4334 13.8225L13.8202 8.43402C14.4413 7.81183 14.4413 6.79832 13.8202 6.17612C13.1952 5.55002 12.1835 5.55002 11.5624 6.17612Z"
            fill="#B8B8B8"
          />
        </svg>
        <div style={{ flex: "1 1 auto" }}>
          <p style={{ fontSize: "15px", color: "#363636" }}>رابط الإحالة</p>
        </div>
      </Link>
      <Link
        className={css.card + " " + css.sov_owner_btn}
        href={`/listings/${listing.id}/edit/custom-booking`}
        style={{ padding: "12px", position: "relative", gap: "8px" }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5 2.5H16.6663V0.83375C16.6663 0.3725 16.2937 0 15.8337 0H15C14.54 0 14.1663 0.3725 14.1663 0.83375V2.5H5.8325V0.83375C5.83375 0.3725 5.46 0 5 0H4.16625C3.70625 0 3.3325 0.3725 3.3325 0.83375V2.5H2.5C1.12125 2.5 0 3.62125 0 5V17.5C0 18.8787 1.12125 20 2.5 20H17.5C18.8787 20 20 18.8787 20 17.5V5C20 3.62125 18.8787 2.5 17.5 2.5ZM17.5 18.3337H2.5C2.04 18.3337 1.66625 17.96 1.66625 17.5V7.53375H18.3325V17.5C18.3337 17.96 17.96 18.3337 17.5 18.3337Z"
            fill="#4D4D4D"
          />
          <path
            d="M7.49828 12.5005C6.57953 12.5005 5.83203 11.753 5.83203 10.8342C5.83203 9.91547 6.57953 9.16797 7.49828 9.16797C8.41703 9.16797 9.16453 9.91547 9.16453 10.8342C9.16453 11.753 8.41703 12.5005 7.49828 12.5005Z"
            fill="#B8B8B8"
          />
          <path
            d="M12.4983 17.5005C11.5795 17.5005 10.832 16.753 10.832 15.8342C10.832 14.9155 11.5795 14.168 12.4983 14.168C13.417 14.168 14.1645 14.9155 14.1645 15.8342C14.1645 16.753 13.417 17.5005 12.4983 17.5005Z"
            fill="#B8B8B8"
          />
          <path
            d="M7.49712 17.5007C7.32337 17.5007 7.14837 17.4469 6.99837 17.3344C6.62962 17.0582 6.55587 16.5357 6.83212 16.1682L11.8321 9.5019C12.1084 9.1344 12.6296 9.05941 12.9984 9.33566C13.3671 9.61191 13.4409 10.1344 13.1646 10.5019L8.16462 17.1682C8.00087 17.3857 7.75087 17.5007 7.49712 17.5007Z"
            fill="#B8B8B8"
          />
        </svg>
        <div style={{ flex: "1 1 auto" }}>
          <p style={{ fontSize: "15px", color: "#363636" }}>عرض خاص</p>
        </div>
        <span className={css.newLabel}>جديد</span>
      </Link>
    </div>
  );
}

function PayCommissionButton({ listing }) {
  if (listing.daily_rentable || !listing?.aqar_commission) return null;
  return (
    <Link href={`/mlr/${listing.id}/commission-fees`}>
      <Icon width={20} height={20} name="v1/commission" />
      <div>
        <p>دفع العمولة</p>
        <p>ادفع العمولة للاستمرار بإضافة إعلانات جديدة</p>
      </div>
      <Icon width={20} height={20} name="leftArrow-searches" />
    </Link>
  );
}
function CommunicationRequests({ listing }) {
  let { whatsapp_requested_count = 0, whatsapp_responded_count = 0 } = listing;
  const requests = whatsapp_requested_count - whatsapp_responded_count;

  if (listing.daily_rentable) return null;
  return (
    <Link
      href={`/listings/${listing.id}/communication-requests`}
      onClick={() => {
        trackEditAdInteraction({ target: "contact_requests" });
      }}
    >
      <Icon width={20} height={20} name="v1/phone-chat" />
      <div>
        <p className={css.whatsapp_requests}>
          طلبات التواصل
          {!!requests && <span>{requests} طلبات</span>}
        </p>
        <p>يعزز تواصلك السريع مع العملاء من أولوية ظهور الإعلان</p>
      </div>
      <Icon width={20} height={20} name="leftArrow-searches" />
    </Link>
  );
}

const RNPL_CATEGORIES = [1, 4, 5, 13, 18, 19, 21, 22, 23];

function PreciseLocationRequests({ listing }) {
  const { previousPath } = usePath();
  const {
    precise_location_request_status,
    precise_location_request_approved_at,
    daily_rentable,
  } = listing;

  if (daily_rentable) return null;

  const renderPreciseLocationStatus = () => {
    if (precise_location_request_status === "pending") {
      return "تحت المراجعة";
    } else if (precise_location_request_status === "approved") {
      return "موقع دقيق";
    } else if (precise_location_request_status === "rejected") {
      return "مرفوض";
    }
  };

  const renderPreciseLocationStatusText = () => {
    if (!precise_location_request_status) {
      return "وثق موقع الإعلان لزيادة الموثوقية";
    }
    if (precise_location_request_status === "pending") {
      return "جاري مراجعة الطلب";
    } else if (precise_location_request_status === "approved") {
      return `تمت الموافقة على الطلب بتاريخ ${dayjs(
        precise_location_request_approved_at,
      ).format("YYYY/MM/DD")}`;
    } else if (precise_location_request_status === "rejected") {
      return "يمكنك تقديم طلب جديد بعد 7 أيام ";
    }
  };

  return (
    <Link
      href={`/listings/precise-location-request`}
      onClick={() => {
        trackRequestPreciseLocation({
          source: previousPath || decodeURI(document?.referrer),
        });
      }}
    >
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.9082 7.38165C12.9082 7.99006 12.7905 8.62889 12.5552 9.29813C12.3198 9.96738 11.9769 10.6637 11.5264 11.387C11.0759 12.1103 10.5144 12.8573 9.84204 13.628C9.16964 14.3986 8.39637 15.1895 7.52225 16.0007C7.37432 16.136 7.20622 16.2374 7.01794 16.305C6.82967 16.3726 6.6414 16.4064 6.45312 16.4064C6.26485 16.4064 6.07658 16.3726 5.88831 16.305C5.70003 16.2374 5.53193 16.136 5.384 16.0007C4.50988 15.1895 3.73661 14.3986 3.06421 13.628C2.3918 12.8573 1.83035 12.1103 1.37984 11.387C0.929326 10.6637 0.5864 9.96738 0.351059 9.29813C0.115718 8.62889 -0.00195312 7.99006 -0.00195312 7.38165C-0.00195312 5.35363 0.646917 3.73797 1.94466 2.53468C3.2424 1.33138 4.74522 0.729736 6.45312 0.729736C8.16103 0.729736 9.66385 1.33138 10.9616 2.53468C12.2593 3.73797 12.9082 5.35363 12.9082 7.38165Z"
          fill="#B8B8B8"
        />
        <path
          d="M14.1693 13.6298L16.5334 11.0001C16.5335 10.9999 16.5337 10.9998 16.5338 10.9996C16.55 10.9819 16.5749 10.9686 16.6074 10.9664C16.6394 10.9643 16.6658 10.974 16.6847 10.9895C16.704 11.0066 16.7093 11.023 16.7101 11.0357C16.711 11.0485 16.708 11.0636 16.6924 11.081C16.6924 11.081 16.6924 11.081 16.6923 11.0811L13.7315 14.3743L13.7303 14.3756C13.7182 14.3892 13.6951 14.4034 13.663 14.406H13.6629H13.6629H13.6628H13.6628H13.6627H13.6626H13.6626H13.6625H13.6625H13.6624H13.6624H13.6623H13.6623H13.6622H13.6621H13.6621H13.662H13.662H13.6619H13.6619H13.6618H13.6618H13.6617H13.6616H13.6616H13.6615H13.6615H13.6614H13.6614H13.6613H13.6613H13.6612H13.6611H13.6611H13.661H13.661H13.6609H13.6609H13.6608H13.6608H13.6607H13.6606H13.6606H13.6605H13.6605H13.6604H13.6604H13.6603H13.6603H13.6602H13.6602H13.6601H13.66H13.66H13.6599H13.6599H13.6598H13.6598H13.6597H13.6597H13.6596H13.6595H13.6595H13.6594H13.6594H13.6593H13.6593H13.6592H13.6592H13.6591H13.6591H13.659H13.6589H13.6589H13.6588H13.6588H13.6587H13.6587H13.6586H13.6586H13.6585H13.6585H13.6584H13.6583H13.6583H13.6582H13.6582H13.6581H13.6581H13.658H13.658H13.6579H13.6578H13.6578H13.6577H13.6577H13.6576H13.6576H13.6575H13.6575H13.6574H13.6574H13.6573H13.6573H13.6572H13.6571H13.6571H13.657H13.657H13.6569H13.6569H13.6568H13.6568H13.6567H13.6567H13.6566H13.6565H13.6565H13.6564H13.6564H13.6563H13.6563H13.6562H13.6562H13.6561H13.6561H13.656H13.656H13.6559H13.6558H13.6558H13.6557H13.6557H13.6556H13.6556H13.6555H13.6555H13.6554H13.6554H13.6553H13.6553H13.6552H13.6551H13.6551H13.655H13.655H13.6549H13.6549H13.6548H13.6548H13.6547H13.6547H13.6546H13.6546H13.6545H13.6545H13.6544H13.6543H13.6543H13.6542H13.6542H13.6541H13.6541H13.654H13.654H13.6539H13.6539H13.6538H13.6538H13.6537H13.6537H13.6536H13.6536H13.6535H13.6534H13.6534H13.6533H13.6533H13.6532H13.6532H13.6531H13.6531H13.653H13.653H13.6529H13.6529H13.6528H13.6528H13.6527H13.6527H13.6526H13.6526H13.6525H13.6524H13.6524H13.6523H13.6523H13.6522H13.6522H13.6521C13.6204 14.406 13.5934 14.3933 13.5774 14.3777L11.8855 12.7316C11.8695 12.716 11.865 12.7009 11.865 12.6874C11.865 12.6737 11.8696 12.6578 11.8866 12.6412L11.3625 12.1046L11.8866 12.6412C11.9034 12.6248 11.928 12.6134 11.9599 12.6134C11.9919 12.6134 12.0185 12.625 12.0371 12.643C12.0372 12.643 12.0373 12.6431 12.0374 12.6432L13.0885 13.6659L13.6477 14.21L14.1693 13.6298ZM14.4987 6.79053C11.0721 6.79053 8.24805 9.50746 8.24805 12.8913C8.24805 16.2747 11.0705 18.9932 14.4987 18.9932C17.9269 18.9932 20.748 16.276 20.748 12.8925C20.748 9.50914 17.9257 6.79053 14.4987 6.79053Z"
          fill="#4D4D4D"
          stroke="white"
          strokeWidth="1.5"
        />
      </svg>

      <div>
        <p className={css.whatsapp_requests}>طلب علامة (موقع دقيق)</p>
        <p>{renderPreciseLocationStatusText()}</p>
      </div>
      {precise_location_request_status ? (
        <span
          className={`${css.preciseLocationStatus} ${css[precise_location_request_status]}`}
        >
          {precise_location_request_status === "approved" && (
            <svg
              width="10"
              height="12"
              viewBox="0 0 10 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 5.09185C10 5.55757 9.90885 6.04657 9.72656 6.55886C9.54427 7.07115 9.27865 7.60414 8.92969 8.15783C8.58073 8.71151 8.14583 9.28331 7.625 9.87322C7.10417 10.4631 6.50521 11.0686 5.82812 11.6895C5.71354 11.793 5.58333 11.8706 5.4375 11.9224C5.29167 11.9741 5.14583 12 5 12C4.85417 12 4.70833 11.9741 4.5625 11.9224C4.41667 11.8706 4.28646 11.793 4.17188 11.6895C3.49479 11.0686 2.89583 10.4631 2.375 9.87322C1.85417 9.28331 1.41927 8.71151 1.07031 8.15783C0.721354 7.60414 0.455729 7.07115 0.273438 6.55886C0.0911458 6.04657 0 5.55757 0 5.09185C0 3.53946 0.502604 2.30272 1.50781 1.38163C2.51302 0.460543 3.67708 0 5 0C6.32292 0 7.48698 0.460543 8.49219 1.38163C9.4974 2.30272 10 3.53946 10 5.09185Z"
                fill="white"
              />
              <path
                d="M4.25635 5.85246L3.74921 5.31621C3.60431 5.163 3.43527 5.08639 3.24207 5.08639C3.04887 5.08639 2.87982 5.163 2.73492 5.31621C2.59003 5.46942 2.51758 5.65136 2.51758 5.86203C2.51758 6.0727 2.59003 6.25464 2.73492 6.40786L3.74921 7.4995C3.89411 7.65272 4.06316 7.72932 4.25635 7.72932C4.44955 7.72932 4.6186 7.65272 4.7635 7.4995L7.33544 4.77996C7.48034 4.62675 7.55279 4.44481 7.55279 4.23414C7.55279 4.02347 7.48034 3.84153 7.33544 3.68832C7.19054 3.5351 7.01847 3.4585 6.81924 3.4585C6.62 3.4585 6.44794 3.5351 6.30304 3.68832L4.25635 5.85246Z"
                fill="#52B44A"
              />
            </svg>
          )}
          {renderPreciseLocationStatus()}
        </span>
      ) : (
        <Icon width={20} height={20} name="leftArrow-searches" />
      )}
    </Link>
  );
}

export function OwnerServices({ listing } = {}) {
  const { token } = useAuthState();
  const { updateContext } = usePath();
  const [refreshListing] = useMutation(REFRESH_LISTING, { context: { token } });
  const { daily_rentable } = listing || {};

  const {
    data: {
      Info: {
        configurations: { rnpl_enabled },
      },
    } = { Info: { configurations: {} } },
  } = useQuery(FINANCING_TEXTS);

  const [addMot] = useMutation(ADD_MOT_LICENSE, {
    context: { token },
  });

  const { category, published, id, price, rnpl_monthly_price } = listing;

  return (
    <>
      {daily_rentable && <ReferralCode listing={listing} />}
      {RNPL_CATEGORIES?.includes(category) && published && rnpl_enabled ? (
        <RnplControls
          rnpl_monthly_price={rnpl_monthly_price}
          id={id}
          price={price}
        />
      ) : null}
      <PromotionControl listing={listing} />
      <h4>خدمات الإعلان</h4>
      <div>
        <div className={css.card + " " + css.ownerServices}>
          <CommunicationRequests listing={listing} />
          <div
            role="button"
            onClick={(event) => {
              refreshListing({ variables: { id: listing?.id } })
                .then(() => {
                  Modal.open(
                    <SuccessAlert
                      text="تم تحديث الإعلان بنجاح"
                      onOk={() => {
                        updateContext({
                          listing: {
                            ...listing,
                            last_update: Date.now() / 1000,
                          },
                        });
                      }}
                    />,
                  )();
                })
                .catch(ErrorModal.handle);
            }}
          >
            <Icon width={20} height={20} name="v1/refresh" />
            <div>
              <p>تحديث</p>
              <p>حدث الإعلان لتفادي الحذف</p>
            </div>
            <button> تحديث</button>
          </div>

          {daily_rentable && (
            <>
              <Link href={`/listings/${listing.id}/edit`}>
                <Icon width={20} height={20} name="v1/price-tag" />
                <div>
                  <p>تعديل الأسعار والأيام المحجوزة</p>
                  <p>حدد أسعار الأيام والمناسبات، وعدل الأيام المحجوزة</p>
                </div>
                <Icon width={20} height={20} name="leftArrow-searches" />
              </Link>
              <Link href={`/listings/${listing.id}/edit/settings`}>
                <Icon width={20} height={20} name="v1/cogg" />
                <div>
                  <p>إعدادات الوحدة</p>
                  <p>أضف أوقات الوصول والخروج وقوانين الوحدة</p>
                </div>
                <Icon width={20} height={20} name="leftArrow-searches" />
              </Link>
              <Link
                onClick={async (e) => {
                  e.preventDefault();
                  Modal.open(
                    <MotPermitModal
                      onSuccess={async (mot_license_number, owner_id) => {
                        return await addMot({
                          variables: {
                            listing_id: listing.id,
                            mot_license_number,
                            owner_id,
                          },
                        });
                      }}
                    />,
                  )(e);
                }}
                href={`/listings/${listing.id}/edit/tourism-permit`}
              >
                <Icon width={20} height={20} name="permitAdd" />

                <div>
                  <p>
                    {listing.mot_license_number
                      ? `ترخيص وزارة السياحة (${listing.mot_license_number})`
                      : "إضافة ترخيص"}
                  </p>
                  <p>إضافة/تعديل ترخيص وزارة السياحة</p>
                </div>

                <Icon width={20} height={20} name="leftArrow-searches" />
              </Link>
            </>
          )}
          <PreciseLocationRequests listing={listing} />
          <Link href={`/listings/${listing.id}/statistics`}>
            <Icon width={20} height={20} name="v1/bar-line-chart" />
            <div>
              <p>الإحصائيات</p>
              <p>اطلع على الإحصائيات التفصيلية للإعلان</p>
            </div>
            <Icon width={20} height={20} name="leftArrow-searches" />
          </Link>
          <PayCommissionButton listing={listing} />
        </div>
      </div>
    </>
  );
}
